import withIframe from './withIframe';
import {noopLap} from './timings.js';

/**
 * Список доступных шрифтов, обнаруженных на устройстве пользователя
 * @param {function(string)} lap Отметка этапа для замеров (timings.js).
 * @returns {Promise<IFontData>}
 */
async function collectFonts(lap = noopLap) {
    const textSize = '50px';
    const testString = 'mmMwWLliI0O&1';
    const baseFonts = ['monospace', 'sans-serif', 'serif'];
    const fontList = [
        'sans-serif-thin',
        'ARNO PRO',
        'Agency FB',
        'Arabic Typesetting',
        'Arial Unicode MS',
        'AvantGarde Bk BT',
        'BankGothic Md BT',
        'Batang',
        'Bitstream Vera Sans Mono',
        'Calibri',
        'Century',
        'Century Gothic',
        'Clarendon',
        'EUROSTILE',
        'Franklin Gothic',
        'Futura Bk BT',
        'Futura Md BT',
        'GOTHAM',
        'Gill Sans',
        'HELV',
        'Haettenschweiler',
        'Helvetica Neue',
        'Humanst521 BT',
        'Leelawadee',
        'Letter Gothic',
        'Levenim MT',
        'Lucida Bright',
        'Lucida Sans',
        'Menlo',
        'MS Mincho',
        'MS Outlook',
        'MS Reference Specialty',
        'MS UI Gothic',
        'MT Extra',
        'MYRIAD PRO',
        'Marlett',
        'Meiryo UI',
        'Microsoft Uighur',
        'Minion Pro',
        'Monotype Corsiva',
        'PMingLiU',
        'Pristina',
        'SCRIPTINA',
        'Segoe UI Light',
        'Serifa',
        'SimHei',
        'Small Fonts',
        'Staccato222 BT',
        'TRAJAN PRO',
        'Univers CE 55 Medium',
        'Vrinda',
        'ZWAdobeF',
    ];

    async function getFonts() {
        return withIframe(async (_, { document }) => {
            // До этой точки — ожидание body страницы и загрузка пустого iframe.
            lap('iframe');
            document.body.style.fontSize = textSize;

            const spansContainer = document.createElement('div');
            spansContainer.style.setProperty('visibility', 'hidden', 'important');

            const defaultWidth = {};
            const defaultHeight = {};

            const createSpan = fontFamily => {
                const span = document.createElement('span');
                const { style } = span;
                style.position = 'absolute';
                style.top = '0';
                style.left = '0';
                style.fontFamily = fontFamily;
                span.textContent = testString;
                spansContainer.appendChild(span);
                return span;
            };

            const createSpanWithFonts = (fontToDetect, baseFont) => createSpan(`'${fontToDetect}',${baseFont}`);

            const initializeBaseFontsSpans = () => baseFonts.map(createSpan);

            const initializeFontsSpans = () => {
                const spans = {};

                for (const font of fontList) {
                    spans[font] = baseFonts.map(baseFont => createSpanWithFonts(font, baseFont));
                }

                return spans;
            };

            const isFontAvailable = fontSpans => baseFonts.some(
                (baseFont, baseFontIndex) =>
                    // eslint-disable-next-line implicit-arrow-linebreak
                    fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] ||
                    fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont],
            );

            const baseFontsSpans = initializeBaseFontsSpans();
            const fontsSpans = initializeFontsSpans();

            document.body.appendChild(spansContainer);
            lap('spans');

            for (let index = 0; index < baseFonts.length; index++) {
                defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth;
                defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight;
            }

            const fonts = fontList.filter(font => isFontAvailable(fontsSpans[font]));
            // Первое чтение offsetWidth запускает layout всех span — основная стоимость.
            lap('measure');
            return fonts;
        });
    }

    const fonts = await getFonts();
    lap('cleanup');
    return {
        fonts,
    };
}

export default collectFonts;